import { BehaviorSubject } from 'rxjs';

export const activeState$ = new BehaviorSubject<{ updating: boolean }>({ updating: false });
